<app-thrive-button [disabled]="isLoading || disabled" (click)="buttonClicked()">
  <span [fxHide]="isLoading">
    <ng-content></ng-content>
  </span>
  <mat-spinner [fxHide]="!isLoading" diameter="20"></mat-spinner>
</app-thrive-button>
